import { useId } from "react";

export default function FormInput({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  required = false,
  ...rest
}) {
  // Without a matching id/htmlFor, this <label> is just nearby text as far
  // as assistive tech is concerned — a screen reader won't announce it when
  // the input gets focus, and clicking the label text won't focus the
  // input either.
  const inputId = useId();

  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={inputId} className="text-[10px] uppercase tracking-widest text-zinc-400 font-bold ml-1">
        {label}
      </label>
      <input
        id={inputId}
        className="w-full p-3.5 bg-zinc-800/30 border border-zinc-700/50 rounded-xl text-white outline-none focus:ring-2 focus:ring-indigo-500 transition-all placeholder-zinc-600"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        type={type}
        required={required}
        {...rest}
      />
    </div>
  );
}